import React from 'react';

import { DigitalCheckoutDeclaration } from 'sellDirect/components/closingDash/closing/DigitalCheckoutDeclaration';
import { LockboxLocation } from 'sellDirect/components/closingDash/closing/LockboxLocation';
import { PhoneNumber } from 'sellDirect/components/closingDash/closing/PhoneNumber';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { isDigitalCheckoutFormValid } from 'sellDirect/helpers/closingDash/closing';
import { UnderContractOffer, ClosedOffer } from 'sellDirect/OfferContext';
import { SaveButton } from 'sellDirect/components/closingDash/form/SaveButton';
import { Flex } from '@opendoor/bricks/core';

interface IProps {
  offer: UnderContractOffer | ClosedOffer;
  loading: boolean;
  resetableForm: IResetableFormRenderProps;
  onSubmitForm: () => void;
}

/**
 * Digital checkout form, inputs besides photo uploads.
 *
 * component-test-check-ignore
 */
export const UploadMoveOutPhotos: React.FC<IProps> = ({
  offer,
  loading,
  resetableForm,
  onSubmitForm,
}) => {
  const photolessOverride = !!offer.closingExperience.digitalCheckout?.photolessOverride;
  const { isValid } = isDigitalCheckoutFormValid(resetableForm?.formState, photolessOverride);

  return (
    <Flex flexDirection="column" gridGap={10}>
      <LockboxLocation resetableForm={resetableForm} />
      <PhoneNumber resetableForm={resetableForm} />
      <DigitalCheckoutDeclaration offer={offer} resetableForm={resetableForm} />
      <SaveButton
        analyticsPrefix="digital-checkout-form-"
        loading={loading}
        disabled={loading || !isValid}
        onClick={onSubmitForm}
        aria-label="Save move out photos and close"
      />
    </Flex>
  );
};
